import React from 'react';
import {useTheme} from '@emotion/react';

// styles
import {Wrapper, Label} from './ProgressCircle-styles';

type Props = {
  percentage: number;
};

const ProgressCircle = ({percentage}: Props) => {
  const theme = useTheme();

  const size = 142;
  const strokeWidth = 18;
  const radius = size / 2 - strokeWidth / 2;
  const circumference = 2 * Math.PI * radius;
  const offset =
    circumference - (percentage / 100) * circumference + percentage / 15;

  // Add a small gap for percentages less than 100%
  const adjustedOffset =
    percentage === 100
      ? circumference - (percentage / 100) * circumference
      : offset;

  return (
    <Wrapper>
      <svg width={size} height={size}>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={theme.color.secondary_10}
          strokeWidth={strokeWidth}
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={theme.color.secondary}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeDasharray={`${circumference} ${circumference}`}
          strokeDashoffset={adjustedOffset}
          transform={`rotate(90 ${size / 2} ${size / 2})`}
        />
      </svg>
      <Label bold="bold">{Math.floor(percentage)}%</Label>
    </Wrapper>
  );
};

export default ProgressCircle;
